// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1_YJH","amount":"Amount_amount__2Zju6","tip":"Amount_tip__3e4VU","tipHeader":"Amount_tipHeader__1CJPG","tipsWrap":"Amount_tipsWrap__yM7Y4"};